import React, { useState, useEffect } from "react";
import ClinicInfoText from "./ClinicInfoText";
import ClinicInfoForm from "./ClinicInfoForm";
//import clinicService from "../../../../services/clinic.service";
import settingsService from "../../../../../services/settings.service";
import { useEyeconxStore } from "../../../../../store/eyeconxStore";
import Loading from "../../../../common/Loading";
const ClinicInfo = () => {
    const [clinicInfo, setClinicInfo] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [logoDimensions, setLogoDimensions] = useState({ width: 0, height: 0 });
    const clinicId = useEyeconxStore((state) => state.user.clinicId);
    // Mock API fetch
    useEffect(() => {
        const fetchClinicInfo = async () => {
            try {
                setIsLoading(true);
                const res = await settingsService.getClinicById(clinicId);
                setClinicInfo(res.data);
                console.log(res.data);
                if (res.data.logo) getImageDimensions(res.data.logo);
            } catch (error) {
                console.error("Error fetching clinic info:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchClinicInfo();
    }, []);

    const getImageDimensions = (url) => {
        const img = new Image();
        img.onload = () => setLogoDimensions({ width: img.width, height: img.height });
        img.src = url;
    };
    const updateClinicInfo= async (data) => {
        try{
            setIsLoading(true);
            const res = await settingsService.updateClinic(clinicId, data);
            //console.log(res);
            //setClinicInfo(res.data);
            setIsLoading(false);
            //alert("Clinic information updated successfully!");
        }catch(error){
                console.log(error);
        }
        finally{
            setIsLoading(false);
        }
    }
    const handleSave = (data) => {
        //setIsLoading(true)
        setClinicInfo({ ...clinicInfo, ...data });
        setIsEditing(false);
        const clinicUpdateData = {
            "id": data.id,
            "name": data.name,
            "email":data.email,
            "phone": data.phone.replace(/\D/g, ""),
            "signature": data.signature,
            "website": data.website,
            "street": data.street,
            "city": data.city,
            "postalCode": data.postalCode,
            "province": data.province,
            "country":data.country,
        }
        updateClinicInfo(clinicUpdateData);

    };

    if (isLoading) {
        return (
           <Loading />
        );
    }

    if (!clinicInfo) {
        return (
            <div className="alert alert-danger text-center">
                <i className="bi bi-exclamation-triangle me-2"></i>
                Failed to load clinic information.
            </div>
        );
    }

    return (
    <>
        <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0">
                        <i className="bi bi-building me-2 text-primary"></i>
                        Clinic Information
                    </h4>
                    <button
                        className={`btn ${isEditing ? "btn-outline-secondary" : "btn-outline-primary"}`}
                        onClick={() => setIsEditing(!isEditing)}
                        type="button"
                    >
                        <i className={`bi ${isEditing ? "bi-x-lg" : "bi-pencil"} me-1`}></i>
                        {isEditing ? "Cancel" : "Edit"}
                    </button>
        </div>
        <div className="">
            {clinicInfo ? (
                isEditing ? (
                    <ClinicInfoForm
                        clinicInfo={clinicInfo}
                        onSubmit={handleSave}
                        onCancel={() => setIsEditing(false)}
                        getImageDimensions={getImageDimensions}
                        logoDimensions={logoDimensions}
                    />
                ) : (
                    <ClinicInfoText clinicInfo={clinicInfo} logoDimensions={logoDimensions} />
                )
            ) : (
                <div className="text-center text-muted py-5">
                    <i className="bi bi-info-circle me-2"></i> Loading clinic information...
                </div>
            )}
        </div>

    </>
    );

};

export default ClinicInfo;
